// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPeriodFilter {
  /** UI значение для фильтра (Н-р: За полгода) **/
  name: string;
  /** Возможные значения фильтра **/
  value: EValue;
}

export enum EValue {
  /** За полгода **/
  'HalfYear' = 'halfYear',
  /** За год **/
  'Year' = 'year',
  /** За всё время **/
  'AllTime' = 'allTime',
}
